import {
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { FieldArray, Form, Formik } from "formik";
import React, { useEffect } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import MainCard from "ui-component/cards/MainCard";
import { gridSpacing } from "store/constant";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import { useNavigate, useParams } from "react-router-dom";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";
import NavigateBackButton from "reuseableTable/NavigateBackButton";

const UpdateEducationDetails = ({ setOpenEdit, setAlumniDetails, alumniDetails, alumniId }) => {
    const RequestId = useRequestIdGenerater();
    const navigate = useNavigate();
    const { id } = useParams();
    const { rendomRequestId, generateTimeStamp } = useTimeStamp();
    const initialValues = {
        educationDetails: [
            {
                id: alumniDetails?.id ?? "",
                educationLevel: alumniDetails?.educationLevel ?? "SENIOR_SECONDARY",
                instituteName: alumniDetails?.instituteName ?? "",
                affiliation: alumniDetails?.affiliation ?? "",
                joiningDate: "",
                courseName: "",
                startMonth: "",
                startYear: "",
                endMonth: "",
                endYear: ""
            },
        ],
    };
    const handleSubmit = (values) => {
        console.log(values, 'valuesss')
        const payload = values.educationDetails?.[0]
        axios
            .put(`/v1/alumni/update-individual/education-details?alumniId=${alumniId}`, payload, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        "serviceToken"
                    )}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        values?.educationDetails[0].joiningDate,
                        values?.educationDetails[0].organizationName + rendomRequestId
                    ),
                },
            })
            .then((value) => {
                setAlumniDetails(value?.data?.data)
                generateTimeStamp();
                dispatch(
                    openSnackbar({
                        open: true,
                        message: "Updated Successfully.",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    })
                );
                setOpenEdit(false)


            })
            .catch((error) => {
                if (error.response.status === 404) {
                    generateTimeStamp();
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: error.response.data.Msg,
                            variant: "alert",
                            alert: {
                                color: "error",
                            },
                            close: false,
                        })
                    );
                } else {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: "Something went wrong",
                            variant: "alert",
                            alert: {
                                color: "error",
                            },
                            close: false,
                        })
                    );
                    generateTimeStamp();
                }
            });
    };
    return (
        <MainCard>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values, handleChange }) => (
                    <Form>
                        <FieldArray
                            name="educationDetails"
                            render={(arrayHelpers) => (
                                <Grid>
                                    {values.educationDetails
                                        ? values.educationDetails.map((items, i) => {
                                            return (
                                                <Grid container spacing={gridSpacing} pt={2}>
                                                    <Grid item xs={12} md={4}>
                                                        <FormControl fullWidth>
                                                            <InputLabel>Education level</InputLabel>
                                                            <Select
                                                                labelId="Batch-select"
                                                                id={`educationDetails.${i}.educationLevel`}
                                                                name={`educationDetails.${i}.educationLevel`}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                }}
                                                                value={items?.educationLevel}
                                                                label="Education level"
                                                            >
                                                                <MenuItem value="SENIOR_SECONDARY">
                                                                    SENIOR SECONDARY
                                                                </MenuItem>
                                                                <MenuItem value="COLLEGE">COLLEGE</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            type="text"
                                                            id={`educationDetails.${i}.instituteName`}
                                                            name={`educationDetails.${i}.instituteName`}
                                                            label="Institute Name"
                                                            value={items.instituteName}
                                                            onChange={handleChange}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            type="text"
                                                            id={`educationDetails.${i}.affiliation`}
                                                            name={`educationDetails.${i}.affiliation`}
                                                            label="Affiliation"
                                                            value={items.affiliation}
                                                            onChange={handleChange}
                                                        />
                                                    </Grid>

                                                    {/* <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                type="date"
                                id={`educationDetails.${i}.joiningDate`}
                                name={`educationDetails.${i}.joiningDate`}
                                label="Joining Date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={items.joiningDate}
                                onChange={handleChange}
                              />
                            </Grid> */}
                                                    {items?.educationLevel !== "SENIOR_SECONDARY" && (
                                                        <Grid item xs={12} md={4}>
                                                            <TextField
                                                                fullWidth
                                                                type="text"
                                                                id={`educationDetails.${i}.courseName`}
                                                                name={`educationDetails.${i}.courseName`}
                                                                label="Course Name"
                                                                value={items.courseName}
                                                                onChange={handleChange}
                                                            />
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            );
                                        })
                                        : null}
                                </Grid>
                            )}
                        />
                        <Grid
                            item
                            md={12}
                            xs={12}
                            sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button variant="contained" color="secondary" type="button" onClick={() => setOpenEdit(false)}>Close</Button>
                            <Button variant="contained" color="primary" type="submit" sx={{ ml: 2 }}>
                                Update
                            </Button>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </MainCard>
    );
};

export default UpdateEducationDetails;
